import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowUpDownOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m7.308 5.889.99-.99L4.399 1 .5 4.899l.99.99 2.21-2.21v10.23h1.4V3.68z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m11.601 15 3.9-3.899-.99-.99-2.21 2.209V2.092h-1.4V12.32l-2.209-2.209-.99.99z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowUpDownOutlinedSize16Glyph.displayName = 'ArrowUpDownOutlinedSize16Glyph';
